import React, { useCallback, useEffect, useState } from "react";
import { FaFacebookF, FaLine, FaTiktok, FaYoutube } from "react-icons/fa";
import packageJson from "../../package.json";
import { getContactOfficeData } from "../api/home";
import ImageWithTooltip from "../components/ImageWithTooltip";

function SiteFooter() {
  const { version } = packageJson;
  const [footerData, setFooterData] = useState("");
  const getData = useCallback(async () => {
    try {
      const response = await getContactOfficeData();

      setFooterData(response);
    } catch (error) {
      console.warn(error);
    }
  }, []);

  useEffect(() => {
    getData();
  }, [getData]);
console.log("footer",footerData)
  const displayCopyRight = (
    <div className="container mx-auto relative border-t-[1px] border-slate-300">
      <div className="md:flex items-center justify-between py-4 px-2 md:px-0">
        <div className="text-sm font-medium text-white text-center md:text-left">
          Copyright © 2024, All Right Reserved. NCSA | National Cyber Security
          Agency
        </div>

        <div className="flex items-center justify-center md:justify-start py-4">
          <a
            href={footerData?.facbooklink}
            target="_blank"
            rel="noreferrer"
            className="bubble-social bg-[#1b77f2] text-lg"
          >
            <FaFacebookF />
          </a>
          <a
            href={footerData?.youtubelink}
            target="_blank"
            rel="noreferrer"
            className="bubble-social bg-[#ff0200] text-lg"
          >
            <FaYoutube />
          </a>
          <a
            href={footerData?.linelink}
            target="_blank"
            rel="noreferrer"
            className="bubble-social bg-[#06c755] text-lg"
          >
            <FaLine />
          </a>
          <a
            href={footerData?.tiktoklink}
            target="_blank"
            rel="noreferrer"
            className="bubble-social bg-[#010101] text-lg"
          >
            <FaTiktok />
          </a>
        </div>
      </div>
    </div>
  );

  return (
    <footer className="site-footer">
      <div className="container mx-auto py-4 px-2 md:px-0">
        <div className="mb-4">
          <ImageWithTooltip
            className="w-36"
            src={footerData?.logo?.path ?? ""}
            alt={footerData?.logo?.altText}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-200">
          <div dangerouslySetInnerHTML={{ __html: footerData?.address_col0 }} />
          <div dangerouslySetInnerHTML={{ __html: footerData?.address_col1 }} />
        </div>
      </div>

      {displayCopyRight}
      <small className="p-4">version {version}</small>
    </footer>
  );
}

export default SiteFooter;
